import React from 'react'
import useAssignTrucks from 'tennders-market/truck/hooks/useAssignTrucks'
import GLoading from 'tennders-market/common/components/element/GLoading'
import useTranslation from 'next-translate/useTranslation'
import DistanceFilter from './DistanceFilter'
import AssignTransactions from './AssignTransactions'

const AssignTrucks = () => {
  const { t } = useTranslation()
  const {
    loading,
    trucks,
    setrange,
    range,
    dateRange,
    setdateRange
  } = useAssignTrucks()

  return (
    <div className="bg-color-white p-10 mt-10">
      <div className="tennders-brokers-trucks-match-load-info">
        <div className="d-flex justify-space align-center mb-20">
          <h3 className="bold mb-0 mr-10">{t('transaction:trucksReadyToAssign')}</h3>
          <DistanceFilter
            dateRange={dateRange}
            setdateRange={setdateRange}
            setrange={setrange}
            range={range}
          />
        </div>
        {loading
          ? <GLoading />
          : <AssignTransactions transactions={trucks} />}
      </div>
    </div>
  )
}

export default AssignTrucks
